import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import campaignPageQuery from './query.graphql';

const CampaignContent = loadable(() =>
  import(/* webpackChunkName: "campaigns" */ './campaign')
);

const Campaign = props => <CampaignContent {...props} />;

Campaign.graphQL = campaignPageQuery;

Campaign.loadOrder = [{}];

const FILTER_URL_PARAMS = [
  'category',
  'price',
  'productRating',
  'storeRating',
  'stores',
];

Campaign.variables = ({
  name,
  list: listSlug,
  min_price: minPrice,
  max_price: maxPrice,
  ...variables
}) => ({
  id: /^\d+$/.test(name) ? parseInt(name, 10) : undefined,
  campaignSlug: name,
  listSlug,
  limit: 20,
  minPrice,
  maxPrice,
  filters: FILTER_URL_PARAMS.map(key =>
    variables[key] ? { key, value: variables[key] } : null
  ).filter(Boolean),
  peakIndexCategoryId: variables.category,
  campaignDeals: name === 'black-friday',
});

Campaign.propTypes = {
  fetchMoreData: PropTypes.func,
};

Campaign.defaultProps = {
  fetchMoreData: () => {},
};

Campaign.isGiftGuide = campaign => campaign && campaign.type === 'GIFTGUIDE';

Campaign.isActive = campaign => campaign && campaign.state === 'ACTIVE';

export default Campaign;
